module.exports = __webpack_public_path__ + "SchoolComparisonReport1-c9cef0a56d04f4dc60e27887dff40d70.png";